export const TOGGLE_DYNAMIC_MESSAGE_FILTER = "TOGGLE_DYNAMIC_MESSAGE_FILTER";
export const TOGGLE_ALWAYS_OPEN_NEW_MESSAGES =
  "TOGGLE_ALWAYS_OPEN_NEW_MESSAGES";
export const TOGGLE_PRESS_ENTER_TO_SEND_MESSAGE =
  "TOGGLE_PRESS_ENTER_TO_SEND_MESSAGE";
export const TOGGLE_RECEIVE_EMAIL_NOTIFICATIONS =
  "TOGGLE_RECEIVE_EMAIL_NOTIFICATIONS";
export const TOGGLE_CHAT_LIST = "TOGGLE_CHAT_LIST";
export const OPEN_CHAT = "OPEN_CHAT";
export const CLOSE_CHAT = "CLOSE_CHAT";
export const CREATE_CHAT = "CREATE_CHAT";
export const COLLAPSE_CHAT = "COLLAPSE_CHAT";
export const COLLAPSE_ALL_CHATS = "COLLAPSE_ALL_CHATS";
export const CHANGE_CHAT = "CHANGE_CHAT";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_USERS = "SET_USERS";
export const UPDATE_NEW_CHAT = "UPDATE_NEW_CHAT";
export const UPDATE_CHAT = "UPDATE_CHAT";
export const SET_CONFIGURATION_ID = "SET_CONFIGURATION_ID";
export const API_SET_CONTEXT_FILTER = "API_SET_CONTEXT_FILTER";
export const API_SET_CONTEXT_LIST = "API_SET_CONTEXT_LIST";
export const API_REFRESH = "API_REFRESH";
export const RECALCULATE_MAX_CHATS = "RECALCULATE_MAX_CHATS";
